import { render, staticRenderFns } from "./UserProfileNewPage.vue?vue&type=template&id=c55a11f4&scoped=true&"
import script from "./UserProfileNewPage.vue?vue&type=script&lang=js&"
export * from "./UserProfileNewPage.vue?vue&type=script&lang=js&"
import style0 from "./UserProfileNewPage.vue?vue&type=style&index=0&id=c55a11f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c55a11f4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
